<template>
  <v-card class="pa-5" elevation="1">
    <v-card-title class="px-0 pt-0">Distribuidores</v-card-title>

    <DataTable
      no-sync
      :headers="headers"
      :items="distributors"
      :loading="loading"
      :slots="slots"
    >
      <template v-slot:actions="{ props: { item } }">
        <ButtonIcon
          color="secondary"
          x-small
          :icon="$icons.cashPlus"
          tooltip="Saldo a receber"
          @click="openBalanceModal(item)"
        />
      </template>
    </DataTable>

    <Dialog :dialog="dialogBalance" no-title :maxWidth="700">
      <AdminDistributorBalanceModal
        v-if="selectedDistributor && dialogBalance"
        slot="content"
        :distributor-id="selectedDistributor.id"
        :distributor-name="selectedDistributor.name"
        @close="closeBalanceModal"
      />
    </Dialog>
  </v-card>
</template>

<script>
import { DataTable, ButtonIcon, Dialog } from '@/components/vuetify';
import AdminDistributorBalanceModal from './components/AdminDistributorBalanceModal.vue';

export default {
  name: 'AdminDistributors',
  components: {
    DataTable,
    ButtonIcon,
    Dialog,
    AdminDistributorBalanceModal,
  },
  data() {
    return {
      loading: false,
      distributors: [],
      dialogBalance: false,
      selectedDistributor: null,
      slots: [{ field: 'actions' }],
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'E-mail', value: 'email' },
        { text: 'Telefone', value: 'phone' },
        { text: 'Revendedores', value: 'resellers_count' },
        { text: 'Ações', value: 'actions', width: 80, align: 'center', sortable: false },
      ],
    };
  },
  mounted() {
    this.fetchDistributors();
  },
  methods: {
    fetchDistributors() {
      this.loading = true;
      this.$api.admin
        .getDistributors()
        .then(({ data }) => {
          this.distributors = (data.distributors || []).map((distributor) => ({
            ...distributor,
            resellers_count: distributor.resellers ? distributor.resellers.length : 0,
          }));
        })
        .catch(() => {
          this.$noty.error('Erro ao carregar os distribuidores');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openBalanceModal(distributor) {
      this.selectedDistributor = distributor;
      this.dialogBalance = true;
    },
    closeBalanceModal() {
      this.dialogBalance = false;
      this.selectedDistributor = null;
    },
  },
};
</script>
